import * as Yup from 'yup'

import { isSsn } from '../../ssn'

const YUP_SSN_METHOD = 'ssn'

Yup.addMethod(Yup.string, YUP_SSN_METHOD, function (errorMessage: string) {
  return this.test(YUP_SSN_METHOD, errorMessage, (value: string | undefined) => isSsn(value))
})
